export const TestIds = {
  container: 'chat-empty-state',
  avatar: 'chat-empty-state-avatar',
  betaBadge: 'chat-empty-state-beta-badge',
  title: 'chat-empty-state-title',
};
